import { useState, useEffect, useCallback } from "react";

// Shared fullscreen behaviour for the media viewers.
// Pass a ref to the element that should go fullscreen.
export default function useFullscreen(ref) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = useCallback(() => {
    if (!document.fullscreenElement) ref.current?.requestFullscreen?.();
    else document.exitFullscreen?.();
  }, [ref]);

  useEffect(() => {
    const onFsChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onFsChange);
    return () => document.removeEventListener("fullscreenchange", onFsChange);
  }, []);

  return { isFullscreen, toggleFullscreen };
}
